export class ErrorOnLogoutException extends Error {
  constructor({ message = 'Error al cerrar sesión', errorCode = '99' }) {
    super(message);
    this.name = this.constructor.name;
    this.errorCode = errorCode;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error().stack;
    }
  }
}
